import { useAuth0 } from '@auth0/auth0-react';
import { ReactNode } from 'react';
import { ReactComponent as Logo } from '../../assets/workpapers-indigo-full.svg';
import { ReactComponent as Backdrop } from '../../assets/workpapers-logo-backdrop.svg';

type OnboardingStepsProps = {
    children: ReactNode | ReactNode[];
};
function OnboardingSidebar({ children }: OnboardingStepsProps): JSX.Element {
    const { logout } = useAuth0();

    return (
        <div className="border-r bg-gray-50 p-8 lg:p-16 flex flex-col relative">
            <Logo />
            <div className="flex flex-col mt-16">{children}</div>
            {/* Backdrop Image */}
            <Backdrop className="bottom-28 right-0 absolute h-[252px] w-[250px] lg:h-[336px] lg:w-[334px]" />
            {/* Actions */}
            <div className="mt-auto w-full flex justify-between">
                <div>
                    <a
                        href="https://support.cimplico.com"
                        target="_blank"
                        rel="noreferrer"
                        className="text-contentPrimary text-sm font-bold"
                    >
                        Need help?
                    </a>
                    <div className="absolute bottom-4 text-gray-600 text-sm">
                        <a href="https://www.cimplico.com/privacy-policy" target="_blank" rel="noreferrer">
                            Privacy Policy
                        </a>
                        <a href="https://www.cimplico.com/terms-conditions/" target="_blank" rel="noreferrer" className="ml-4">
                            Terms & Conditions
                        </a>
                    </div>
                </div>
                <button className="text-contentPrimary text-sm font-bold" onClick={(): Promise<void> => logout()}>
                    Logout
                </button>
            </div>
        </div>
    );
}

export default OnboardingSidebar;
